import { FillInTheBlanksView, inputPinPhases } from '../../playerStore.types';
import { PlayerPinReducer, PlayerPinReducerFactory } from '../reducers.types';
import { nextPhase } from '../reducers.utils';

export type FillInTheBlanksReducer = PlayerPinReducer<FillInTheBlanksView>;

export const createFillInTheBlanksReducer: PlayerPinReducerFactory<FillInTheBlanksView> = () => fillInTheBlanksReducer;

const fillInTheBlanksReducer: FillInTheBlanksReducer = {
  phases: inputPinPhases,
  initial: () => {
    return {
      type: 'FILL_IN_THE_BLANKS',
      phase: 'input',
    };
  },
  hasNextView: (_, currentView, direction) => {
    return nextPhase(currentView.phase, fillInTheBlanksReducer.phases, direction) !== null;
  },
  handleNextView: (state, prev, direction) => {
    if (!state.currentView) {
      return false;
    }

    const next = nextPhase(prev.phase, fillInTheBlanksReducer.phases, direction);
    if (next) {
      return {
        ...prev,
        type: 'FILL_IN_THE_BLANKS',
        phase: next,
      };
    }
    return false;
  },
  onNextView: async (state, prev, __, services, setBackgroundActionAction) => {
    if (prev.phase === 'input') {
      const action = () => services.apiService.fillInTheBlanks.checkPinStudentAnswers(state.currentPinId);
      setBackgroundActionAction?.(action);
      return action();
    }
    return null;
  },
  onEntriesUpdate: (_, currentView) => {
    return {
      ...currentView,
    };
  },
};
